import type { Place, Position } from '../../types';

export const MINIMIZE_PLAYER_POSITION_ADJUST = 12;

export function positionAdjustMinimizePlayer(
  position: Position,
  place: Place,
  adjust = MINIMIZE_PLAYER_POSITION_ADJUST
) {
  if (position === 'bottomCenter' && place === 'right') {
    return `${adjust}px`;
  }

  return positionAdjust(position, place, adjust);
}

export function positionAdjust(
  position: Position,
  place: Place,
  adjust = MINIMIZE_PLAYER_POSITION_ADJUST
) {
  return positionCheck(position, place) ? `${adjust}px` : '';
}

export function positionCheck(position: Position, place: Place) {
  return position.toLowerCase().includes(place);
}
